import RegionDetail from './RegionDetail';

export default RegionDetail;
